export const environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://dev.hpslife.co.uk',
  version: '1.0.0',
  enableDebug: true,
  // Add other environment-specific configurations here
}; 